module.exports = __webpack_public_path__ + "static/media/google_logo.686f8efa.svg";